import { getProduct } from '../common/callAPIs';
import { isNil } from 'lodash';
import { useEffect, useState } from 'react';
import { replaceS3WithCF } from '../common/replaceS3WithCF';
import { loadProduct } from '../js/webGL';

function validateData(design_hub_object) {
  if (!isNil(design_hub_object.logos)) {
    for (const logo of design_hub_object.logos) {
      if (isNil(logo.Scale)) logo.Scale = 1;
      if (isNil(logo.Rotate)) logo.Rotate = 1;
    }
  }

  //TB Disable text features for 1st release on 2025-04-27
  // if (!isNil(design_hub_object.texts)) {
  //   design_hub_object.texts = [];
  // }

  return design_hub_object;
}

export function useLoadProduct(
  queryInfo = {},
  productInfo = {},
  defaultStyleLoaded = false,
  styleList = [],
) {
  const { customer_id, cart_item_id, order_item_id } = productInfo;
  const { BASE_URL, STORE_CODE, TOKEN } = queryInfo;
  const [product, setProduct] = useState({});

  useEffect(() => {
    if (!defaultStyleLoaded) {
      return;
    }

    getProduct(queryInfo, productInfo)
      .then((res) => res.json())
      .then((data) => {
        if (isNil(data)) throw new Error('Product data is null!!!');

        console.log('Query info', data);
        data.origin_obj_main = replaceS3WithCF(data.origin_obj_main);
        data.texture_normal = replaceS3WithCF(data.texture_normal);

        const design_hub_object_fromServer = JSON.parse(data?.design_hub_object || '{}');

        let design_hub_object = validateData(design_hub_object_fromServer);
        console.log('design_hub_object', design_hub_object);
        if (
          typeof design_hub_object === 'object' &&
          Array.isArray(design_hub_object.styles) &&
          design_hub_object.styles.length === 0 &&
          styleList.length > 0
        ) {
          design_hub_object = { ...design_hub_object, styles: [structuredClone(styleList[0])] };
        }
        const currentProduct = {
          Id: data?.id,
          Name: data?.product_name,
          Texture: data?.texture?.filter((item) => !!item),
          Mesh: data?.origin_obj_main,
          TextureNormal: data?.texture_normal,
          PartOpacities: null,
          product_id: data?.product_id,
          cart_item_id,
          cart_id: data?.cart_id,
          order_item_id,
          customer_id,
          url: `${BASE_URL}/${STORE_CODE}`,
          token: TOKEN,
          design_hub_object,
        };

        setProduct(currentProduct);
        loadProduct(currentProduct);
        window.restoreDecals = {
          product: {
            Id: data?.id,
            Name: data?.product_name,
            Texture: data?.texture,
            Mesh: data?.origin_obj_main,
            TextureNormal: data?.texture_normal,
            Texts: data?.texts,
            PartOpacities: null,
          },
          ...design_hub_object,
        };
      })
      .catch((err) => {
        console.log('ERROR WHEN LOADING PRODUCT: ', err.message);
      });
  }, [defaultStyleLoaded]);

  return { product };
}
